import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class EventService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation EVENT_UPDATE(
          $id: String!
          $data: EventInput!
        ) {
          eventUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.eventUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation EVENT_DESTROY($ids: [String!]!) {
          eventDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.eventDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation EVENT_CREATE($data: EventInput!) {
          eventCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.eventCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation EVENT_IMPORT(
          $data: EventInput!
          $importHash: String!
        ) {
          eventImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.eventImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query EVENT_FIND($id: String!) {
          eventFind(id: $id) {
            id
            title
            description
            date
            hour
            duration
            location
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.eventFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query EVENT_LIST(
          $filter: EventFilterInput
          $orderBy: EventOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          eventList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              title
              description
              date
              hour
              duration
              location
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.eventList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query EVENT_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          eventAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.eventAutocomplete;
  }
}
